import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Customer } from '@shared/models/customer';
import { CustomerService } from '@core/services/customer/customer.service';
import { BaseComponent } from '@core/components/base/base.component';
import { CustomerInfoWrapperComponent } from '../customer-info-wrapper/customer-info-wrapper.component';
import { PonchoUIModule } from '@poncho/ui';
import { NgTemplateOutlet } from '@angular/common';

@Component({
    selector: 'app-profile-section',
    templateUrl: './profile-section.component.html',
    styleUrls: ['./profile-section.component.scss'],
    standalone: true,
    imports: [NgTemplateOutlet, PonchoUIModule]
})

export class ProfileSectionComponent extends BaseComponent implements OnInit, OnDestroy {

    customer: Customer;
    showLoading: boolean = true;
    destroySubject$: Subject<void> = new Subject();

    constructor(
        private customerService: CustomerService,
        private dialog: MatDialog,
    ) {
        super()
    }

    ngOnInitServer() {

    }

    ngOnInitBrowser() {
        this.customerService.customer
            .pipe(takeUntil(this.destroySubject$))
            .subscribe(data => {
                this.customer = data;
                if (this.customer && Object.keys(this.customer).length !== 0) {
                    this.showLoading = false;
                }
            });
        this.customerService.getCustomer();
    }

    ngOnDestroy() {
        this.destroySubject$.next();
        this.destroySubject$.complete();
    }

    openProfileDialog() {
        const dialogConfig = new MatDialogConfig();
        // TODO: api call everytime getting called
        this.dialog.open(CustomerInfoWrapperComponent, dialogConfig).afterClosed().subscribe(() => {
            this.customerService.getCustomer();
        });
    }

    formatBirthday() {
        return this.customer.customer_info.birthday.split('-').reverse().join('/');
    }
}
